module.exports = __webpack_public_path__ + "static/media/dorp.9b5a9284.jpg";